import { Link } from '@hologram-dimension/link';
import useSimDetails from 'api/sims/useSimDetails';
import clsx from 'clsx/lite';
import { type FC } from 'react';
import ClickToCopy from 'components/ClickToCopy/ClickToCopy';
import styles from './ProfileAndICCID.module.css';

interface ProfileAndICCIDProps {
  profileUrl: string;
  hologramSimId?: HologramSimId;
}

const ProfileAndICCID: FC<ProfileAndICCIDProps> = ({ profileUrl, hologramSimId }) => {
  const { simDetails, error, isLoading } = useSimDetails(hologramSimId);

  if (error) {
    return null;
  }

  return !isLoading ? (
    <div>
      <Link
        type="inline"
        to={profileUrl}
        ariaLabel="View profile"
        className={clsx(!simDetails.profileName && styles.numeric)}
      >
        {simDetails.profileName ?? simDetails.activeProfileIccid}
      </Link>
      {simDetails.profileName && (
        <span className={styles.numeric}>
          {' '}
          <ClickToCopy
            value={simDetails.activeProfileIccid ?? ''}
            label={simDetails.activeProfileIccid}
          />
        </span>
      )}
    </div>
  ) : (
    'Loading...'
  );
};

export default ProfileAndICCID;
